import { render, staticRenderFns } from "./eventInvoices.vue?vue&type=template&id=446aa946"
import script from "./eventInvoices.vue?vue&type=script&lang=js"
export * from "./eventInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports